import { Base, ControlProperty } from '../../../../../common/models';
import { ApprovalStatusEnum, COUNTRIES, Language, TIMEZONE_LIST } from '../../../../../common/constants';
import { TimezoneModel } from '../../../../../common/models/timezone.model';
import { DraggableFilterType } from '../../../../constants';
import { UserRolesModel } from '../models';
import { HubListStateModel } from '../../hub';
export enum UserOwnerType {
  Organization = 'ORGANIZATION',
  Carrier = 'CARRIER',
  Customer = 'CUSTOMER',
}

export enum UserDeactivationApproach {
  FixedDate = 'FIXED_DATE',
  MonthOfInactivity = 'MONTH_OF_INACTIVITY',
}

export enum UserState {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum UserListFilterName {
  ApprovalStatus = 'approvalStatus',
  UserType = 'ownerType', //dropdown (supplier,carrier,customer)
  Status = 'active', // dropdown true or false
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  Country = 'country', //drowdown
  Timezone = 'timezone', //dropdown
  DefaultLanguage = 'defaultLanguage', //dropdown
  Department = 'department',
  AssignedRoles = 'assignedRole', //popup
  AssignedLocations = 'assignedLocation', //popup
  PartnerOwners = 'partnerOwners',
  AssignedRoleRoleGroup = 'assignedRoleRoleGroup',
}

export const USER_FILTER_TYPE_BY_NAME: Map<UserListFilterName, DraggableFilterType> = new Map([
  [UserListFilterName.Email, DraggableFilterType.Input],
  [UserListFilterName.PartnerOwners, DraggableFilterType.CheckboxListPopup],
  [UserListFilterName.FirstName, DraggableFilterType.Input],
  [UserListFilterName.LastName, DraggableFilterType.Input],
  [UserListFilterName.Department, DraggableFilterType.Input],
  [UserListFilterName.UserType, DraggableFilterType.DropDownSelect],
  [UserListFilterName.Status, DraggableFilterType.DropDownSelect],
  [UserListFilterName.Country, DraggableFilterType.DropDownSearchSelect],
  [UserListFilterName.Timezone, DraggableFilterType.DropDownSelect],
  [UserListFilterName.DefaultLanguage, DraggableFilterType.DropDownSelect],
  [UserListFilterName.AssignedRoles, DraggableFilterType.RadioButtonListPopup],
  [UserListFilterName.AssignedLocations, DraggableFilterType.DropDownSearchSelect],
]);

export const USER_FILTER_SELECT_OPTIONS_BY_NAME = new Map<UserListFilterName, string[] | Base[]>([
  [UserListFilterName.UserType, Object.values(UserOwnerType)],
  [UserListFilterName.Status, Object.values(UserState)],
  [
    UserListFilterName.Timezone,
    TIMEZONE_LIST.map((timezone: TimezoneModel) => ({ id: timezone.utc[0], name: timezone.text })),
  ],
  [UserListFilterName.DefaultLanguage, Object.values(Language)],
  [UserListFilterName.Country, COUNTRIES],
  [UserListFilterName.AssignedLocations, []],
]);

export const USER_FILTER_RADIO_OPTIONS_BY_NAME = new Map<
  UserListFilterName,
  string[] | UserRolesModel | HubListStateModel
>([[UserListFilterName.AssignedRoles, []]]);

export class UserListFiltersModelBase {
  [UserListFilterName.ApprovalStatus]: ApprovalStatusEnum = null;
  [UserListFilterName.UserType]: string = null;
  [UserListFilterName.Status]: boolean = null;
  [UserListFilterName.PartnerOwners]: string[] = null;
  [UserListFilterName.Email]: string = null;
  [UserListFilterName.FirstName]: string = null;
  [UserListFilterName.LastName]: string = null;
  [UserListFilterName.Country]: string = null;
  [UserListFilterName.Timezone]: string = null;
  [UserListFilterName.DefaultLanguage]: Language[] = null;
  [UserListFilterName.Department]: string = null;
  [UserListFilterName.AssignedRoles]: string = null;
  [UserListFilterName.AssignedRoleRoleGroup]: string = null;
  [UserListFilterName.AssignedLocations]: string = null;

  constructor(params?: UserListFiltersModelBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
export class UserListFilterForm {
  constructor(
    model: UserListFiltersModelBase,
    public approvalStatus: ControlProperty<ApprovalStatusEnum> = [model.approvalStatus, []],
    public ownerType: ControlProperty<string> = [model.ownerType, []],
    public active: ControlProperty<boolean> = [model.active, []],
    public email: ControlProperty<string> = [model.email, []],
    public partnerOwners: ControlProperty<string[]> = [model.partnerOwners, []],
    public firstName: ControlProperty<string> = [model.firstName, []],
    public lastName: ControlProperty<string> = [model.lastName, []],
    public country: ControlProperty<string> = [model.country, []],
    public timezone: ControlProperty<string> = [model.timezone, []],
    public defaultLanguage: ControlProperty<Language[]> = [model.defaultLanguage, []],
    public department: ControlProperty<string> = [model.department, []],
    public assignedRole: ControlProperty<string> = [model.assignedRole, []],
    public assignedRoleRoleGroup: ControlProperty<string> = [model.assignedRoleRoleGroup, []],
    public assignedLocation: ControlProperty<string> = [model.assignedLocation, []],
  ) {}
}
